(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["categories"] && !Shopify.designMode) return;
  try {
    
(function () {
  const overlay   = document.getElementById('catOverlay');
  const sheet     = document.getElementById('catSheet');
  const closeBtn  = document.getElementById('catSheetClose');
  const ctaBtn    = document.getElementById('catSheetCta');
  const titleEl   = document.getElementById('catSheetTitle');
  const descEl    = document.getElementById('catSheetDesc');
  const photoEl   = document.getElementById('catSheetPhoto');

  let lastFocused = null;

  function openSheet(btn) {
    lastFocused = btn;

    titleEl.textContent = btn.dataset.catName || '';
    descEl.textContent  = btn.dataset.catDesc || '';

    if (btn.dataset.catImg) {
      photoEl.src    = btn.dataset.catImg;
      photoEl.alt    = btn.dataset.catImgAlt || '';
      photoEl.hidden = false;
    } else {
      photoEl.hidden = true;
      photoEl.src    = '';
    }

    sheet.hidden = false;
    sheet.removeAttribute('aria-hidden');
    overlay.classList.add('is-active');
    overlay.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';

    // open クラスは1フレーム遅らせてアニメーションを発火させる
    requestAnimationFrame(() => sheet.classList.add('is-open'));

    closeBtn.focus();
  }

  function closeSheet() {
    sheet.classList.remove('is-open');
    overlay.classList.remove('is-active');
    document.body.style.overflow = '';

    sheet.addEventListener('transitionend', function onEnd() {
      sheet.hidden = true;
      sheet.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      sheet.removeEventListener('transitionend', onEnd);
      if (lastFocused) lastFocused.focus();
    }, { once: true });
  }

  function goToStores() {
    closeSheet();
    setTimeout(function () {
      // アコーディオンを開く
      var btn = document.getElementById('store-toggle-btn');
      var acc = document.getElementById('store-accordion');
      if (btn && acc) {
        btn.setAttribute('aria-expanded', 'true');
        btn.classList.add('open');
        acc.removeAttribute('hidden');
      }
      var storesEl = document.getElementById('stores');
      if (storesEl) storesEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 220);
  }

  // 店頭カードのクリック
  document.querySelectorAll('.cat-card-store').forEach(function (btn) {
    btn.addEventListener('click', function () { openSheet(btn); });
  });

  closeBtn.addEventListener('click', closeSheet);
  overlay.addEventListener('click', closeSheet);
  ctaBtn.addEventListener('click', goToStores);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !sheet.hidden) closeSheet();
  });

  // スワイプで閉じる（スマホ）
  var startY = 0;
  sheet.addEventListener('touchstart', function (e) {
    startY = e.touches[0].clientY;
  }, { passive: true });
  sheet.addEventListener('touchend', function (e) {
    if (e.changedTouches[0].clientY - startY > 80) closeSheet();
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function() {
  // ===== DRAWER =====
  const openBtn  = document.getElementById('drawer-open-btn');
  const closeBtn = document.getElementById('drawer-close-btn');
  const drawer   = document.getElementById('drawer');
  const overlay  = document.getElementById('drawer-overlay');

  function openDrawer() {
    drawer.removeAttribute('hidden');
    drawer.classList.add('open');
    overlay.classList.add('open');
    openBtn.setAttribute('aria-expanded', 'true');
    closeBtn.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    openBtn.setAttribute('aria-expanded', 'false');
    openBtn.focus();
    drawer.addEventListener('transitionend', function handler() {
      drawer.setAttribute('hidden', '');
      drawer.removeEventListener('transitionend', handler);
    }, { once: true });
  }

  openBtn.addEventListener('click', openDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer();
  });

  // Accordion toggles
  document.querySelectorAll('.drawer-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      const subId = this.getAttribute('aria-controls');
      const sub = document.getElementById(subId);

      this.setAttribute('aria-expanded', String(!expanded));
      if (sub) sub.classList.toggle('open', !expanded);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["live-shop"] && !Shopify.designMode) return;
  try {
    
(function() {
  var WEEKDAYS = ['日','月','火','水','木','金','土'];

  function pad(n, len) { var s = String(n); while (s.length < len) s = '0' + s; return s; }
  function ymd(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1, 2) + '-' + pad(d.getDate(), 2); }

  // 変則日リスト（textarea）をパース。
  // 書式: YYYY-MM-DD=>YYYY-MM-DD            （振替）
  //       YYYY-MM-DD=>                       （休止）
  //       YYYY-MM-DD=>YYYY-MM-DD,HH:MM-HH:MM （振替＋時刻変更）
  function parseExceptions(raw) {
    if (!raw) return [];
    var out = [];
    raw.split(/\r?\n/).forEach(function(line) {
      line = line.trim();
      if (!line || line.charAt(0) === '#') return;
      var arrowIdx = line.indexOf('=>');
      if (arrowIdx < 0) return;
      var fromPart = line.substring(0, arrowIdx).trim();
      var rest = line.substring(arrowIdx + 2).trim();
      if (!/^\d{4}-\d{2}-\d{2}$/.test(fromPart)) return;
      var to = null, start = null, end = null;
      if (rest) {
        var commaIdx = rest.indexOf(',');
        var datePart = (commaIdx < 0 ? rest : rest.substring(0, commaIdx)).trim();
        var timePart = commaIdx < 0 ? '' : rest.substring(commaIdx + 1).trim();
        if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) to = datePart;
        if (timePart) {
          var m = timePart.match(/^(\d{1,2}):(\d{2})\s*-\s*(\d{1,2}):(\d{2})$/);
          if (m) {
            start = pad(parseInt(m[1], 10), 2) + ':' + m[2];
            end   = pad(parseInt(m[3], 10), 2) + ':' + m[4];
          }
        }
      }
      out.push({ from: fromPart, to: to, start: start, end: end });
    });
    return out;
  }

  function findException(exceptions, key) {
    for (var i = 0; i < exceptions.length; i++) {
      if (exceptions[i].from === key) return exceptions[i];
    }
    return null;
  }

  function formatStr(d, sH, sM, eH, eM) {
    return (d.getMonth() + 1) + '\u6708' + d.getDate() + '\u65e5\uff08' + WEEKDAYS[d.getDay()] + '\uff09'
      + pad(sH, 2) + ':' + pad(sM, 2) + '\uff5e' + pad(eH, 2) + ':' + pad(eM, 2) + '\u9803';
  }

  function getNextLive(targetDay, cutoffHour, cutoffMin, liveHour, liveMin, endHour, endMin, exceptions) {
    var now = new Date();
    var today0 = new Date(now); today0.setHours(0, 0, 0, 0);

    var diff = (targetDay - today0.getDay() + 7) % 7;
    var base = new Date(today0);
    base.setDate(today0.getDate() + diff);

    // 例外を反映しながら、未来（または当日締切前）の最初の対象日を探す。
    // 60週=約1年あれば現実的な変則ケースは網羅できる。
    for (var iter = 0; iter < 60; iter++) {
      var ex = findException(exceptions, ymd(base));
      var d, sH = liveHour, sM = liveMin, eH = endHour, eM = endMin;
      var skip = false;

      if (ex) {
        if (ex.to) {
          var p = ex.to.split('-');
          d = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
          if (ex.start) { var s = ex.start.split(':'); sH = parseInt(s[0], 10); sM = parseInt(s[1], 10); }
          if (ex.end)   { var e = ex.end.split(':');   eH = parseInt(e[0], 10); eM = parseInt(e[1], 10); }
        } else {
          skip = true; // 休止
        }
      } else {
        d = new Date(base);
      }

      if (!skip) {
        var diffDay = Math.round((d - today0) / 86400000);
        if (diffDay > 0) {
          return formatStr(d, sH, sM, eH, eM);
        } else if (diffDay === 0) {
          var pastCut = now.getHours() > cutoffHour ||
            (now.getHours() === cutoffHour && now.getMinutes() >= cutoffMin);
          if (!pastCut) return formatStr(d, sH, sM, eH, eM);
        }
        // 振替先が過去 or 当日締切後 → 次週へ
      }

      base.setDate(base.getDate() + 7);
    }
    return '';
  }

  document.querySelectorAll('[id^="live-day-date-"]').forEach(function(el) {
    // 昼ライブ: 毎週火曜(2) 12:15〜14:30頃 / 火曜15:00を過ぎたら翌週
    var ex = parseExceptions(el.dataset.liveExceptions || '');
    el.textContent = getNextLive(2, 15, 0, 12, 15, 14, 30, ex);
  });
  document.querySelectorAll('[id^="live-night-date-"]').forEach(function(el) {
    // 夜ライブ: 毎週土曜(6) 19:30〜21:00頃 / 土曜21:00を過ぎたら翌週
    var ex = parseExceptions(el.dataset.liveExceptions || '');
    el.textContent = getNextLive(6, 21, 0, 19, 30, 21, 0, ex);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-live-guide"] && !Shopify.designMode) return;
  try {
    
(function() {
  var WD = ['日','月','火','水','木','金','土'];

  function pad(n, len) { var s = String(n); while (s.length < len) s = '0' + s; return s; }
  function ymd(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1, 2) + '-' + pad(d.getDate(), 2); }

  // 変則日リスト（textarea）をパース。
  // 書式: YYYY-MM-DD=>YYYY-MM-DD（振替）／YYYY-MM-DD=>（休止）／YYYY-MM-DD=>YYYY-MM-DD,HH:MM-HH:MM（時刻変更つき）
  function parseExceptions(raw) {
    if (!raw) return [];
    var out = [];
    raw.split(/\r?\n/).forEach(function(line) {
      line = line.trim();
      if (!line || line.charAt(0) === '#') return;
      var arrowIdx = line.indexOf('=>');
      if (arrowIdx < 0) return;
      var fromPart = line.substring(0, arrowIdx).trim();
      var rest = line.substring(arrowIdx + 2).trim();
      if (!/^\d{4}-\d{2}-\d{2}$/.test(fromPart)) return;
      var to = null, start = null, end = null;
      if (rest) {
        var commaIdx = rest.indexOf(',');
        var datePart = (commaIdx < 0 ? rest : rest.substring(0, commaIdx)).trim();
        var timePart = commaIdx < 0 ? '' : rest.substring(commaIdx + 1).trim();
        if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) to = datePart;
        if (timePart) {
          var m = timePart.match(/^(\d{1,2}):(\d{2})\s*-\s*(\d{1,2}):(\d{2})$/);
          if (m) {
            start = pad(parseInt(m[1], 10), 2) + ':' + m[2];
            end   = pad(parseInt(m[3], 10), 2) + ':' + m[4];
          }
        }
      }
      out.push({ from: fromPart, to: to, start: start, end: end });
    });
    return out;
  }

  function findEx(exceptions, key) {
    for (var i = 0; i < exceptions.length; i++) {
      if (exceptions[i].from === key) return exceptions[i];
    }
    return null;
  }

  function fmt(d, h, m, eH, eM) {
    return (d.getMonth() + 1) + '月' + d.getDate() + '日（' + WD[d.getDay()] + '）'
      + pad(h, 2) + ':' + pad(m, 2) + '〜' + pad(eH, 2) + ':' + pad(eM, 2) + '頃';
  }

  function nextLive(dow, cutH, cutM, h, m, eH, eM, exceptions) {
    var now = new Date();
    var today0 = new Date(now); today0.setHours(0, 0, 0, 0);
    var diff = (dow - today0.getDay() + 7) % 7;
    var base = new Date(today0);
    base.setDate(today0.getDate() + diff);

    for (var iter = 0; iter < 60; iter++) {
      var ex = findEx(exceptions, ymd(base));
      var d, sH = h, sM = m, _eH = eH, _eM = eM;
      var skip = false;

      if (ex) {
        if (ex.to) {
          var p = ex.to.split('-');
          d = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
          if (ex.start) { var s = ex.start.split(':'); sH = parseInt(s[0], 10); sM = parseInt(s[1], 10); }
          if (ex.end)   { var e = ex.end.split(':');   _eH = parseInt(e[0], 10); _eM = parseInt(e[1], 10); }
        } else {
          skip = true;
        }
      } else {
        d = new Date(base);
      }

      if (!skip) {
        var diffDay = Math.round((d - today0) / 86400000);
        if (diffDay > 0) {
          return fmt(d, sH, sM, _eH, _eM);
        } else if (diffDay === 0) {
          var pastCut = now.getHours() > cutH || (now.getHours() === cutH && now.getMinutes() >= cutM);
          if (!pastCut) return fmt(d, sH, sM, _eH, _eM);
        }
      }
      base.setDate(base.getDate() + 7);
    }
    return '';
  }

  function applyTo(ids, dow, cutH, cutM, h, m, eH, eM) {
    ids.forEach(function(id) {
      var el = document.getElementById(id);
      if (!el) return;
      var ex = parseExceptions(el.dataset.liveExceptions || '');
      el.textContent = nextLive(dow, cutH, cutM, h, m, eH, eM, ex);
    });
  }

  applyTo(['lg-day-date', 'lg-day-date-2'],     2, 15, 0, 12, 15, 14, 30);
  applyTo(['lg-night-date', 'lg-night-date-2'], 6, 21, 0, 19, 30, 21, 0);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sns-line"]) return;
  try {
    
(function () {
  var overlay  = document.getElementById('lineOverlay');
  var sheet    = document.getElementById('lineSheet');
  var closeBtn = document.getElementById('lineSheetClose');

  if (!sheet) return;

  var lastFocused = null;

  window.openLineSheet = function (trigger) {
    lastFocused = trigger || document.activeElement;
    sheet.hidden = false;
    sheet.removeAttribute('aria-hidden');
    overlay.classList.add('is-active');
    overlay.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    closeBtn.focus();
  };

  function closeSheet() {
    sheet.classList.remove('is-open');
    overlay.classList.remove('is-active');
    document.body.style.overflow = '';
    sheet.addEventListener('transitionend', function onEnd() {
      sheet.hidden = true;
      sheet.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      sheet.removeEventListener('transitionend', onEnd);
      if (lastFocused) lastFocused.focus();
    }, { once: true });
  }

  closeBtn.addEventListener('click', closeSheet);
  overlay.addEventListener('click', closeSheet);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !sheet.hidden) closeSheet();
  });

  // スワイプで閉じる
  var startY = 0;
  sheet.addEventListener('touchstart', function (e) { startY = e.touches[0].clientY; }, { passive: true });
  sheet.addEventListener('touchend', function (e) {
    if (e.changedTouches[0].clientY - startY > 80) closeSheet();
  }, { passive: true });

  // data-line-trigger 属性のある要素をバインド
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-line-trigger]');
    if (el) { e.preventDefault(); window.openLineSheet(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stores"] && !Shopify.designMode) return;
  try {
    
(function() {
  var btn = document.getElementById('store-toggle-btn');
  var acc = document.getElementById('store-accordion');
  if (!btn || !acc) return;

  function openStores() {
    btn.setAttribute('aria-expanded', 'true');
    btn.classList.add('open');
    acc.removeAttribute('hidden');
  }

  btn.addEventListener('click', function() {
    var expanded = this.getAttribute('aria-expanded') === 'true';
    this.setAttribute('aria-expanded', String(!expanded));
    this.classList.toggle('open', !expanded);
    if (!expanded) {
      acc.removeAttribute('hidden');
    } else {
      acc.setAttribute('hidden', '');
    }
  });

  // #stores ハッシュで遷移してきたときは自動で展開
  function checkHash() {
    if (window.location.hash === '#stores') {
      openStores();
      document.getElementById('stores').scrollIntoView({ behavior: 'smooth' });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkHash);
  } else {
    checkHash();
  }
  window.addEventListener('hashchange', checkHash);
})();

  } catch(e) { console.error(e); }
})();
})();
